import { render, staticRenderFns } from "./LedgerReport.vue?vue&type=template&id=d5ba811a&scoped=true&"
import script from "./LedgerReport.vue?vue&type=script&lang=js&"
export * from "./LedgerReport.vue?vue&type=script&lang=js&"
import style0 from "./LedgerReport.vue?vue&type=style&index=0&id=d5ba811a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ba811a",
  null
  
)

export default component.exports